/** Local warning only; cannot determine whether a question or handwriting is correct. */
export function photoQualityWarning(image: HTMLImageElement): string {
  if (Math.min(image.naturalWidth, image.naturalHeight) < 700)
    return 'This photo is small. Retake closer so every line is readable, or keep it if the text is clear.';
  try {
    const scale = Math.min(1, 900 / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(3, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(3, Math.round(image.naturalHeight * scale));
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    const gray = (i: number) =>
      0.299 * data[i * 4] + 0.587 * data[i * 4 + 1] + 0.114 * data[i * 4 + 2];
    let sum = 0,
      squares = 0,
      count = 0;
    for (let y = 1; y < canvas.height - 1; y++)
      for (let x = 1; x < canvas.width - 1; x++) {
        const i = y * canvas.width + x;
        const v =
          4 * gray(i) - gray(i - 1) - gray(i + 1) - gray(i - canvas.width) - gray(i + canvas.width);
        sum += v;
        squares += v * v;
        count++;
      }
    return count && squares / count - (sum / count) ** 2 < 18
      ? 'This photo may be blurry or have little contrast. Retake with steady hands and good light, or keep it if every line is readable.'
      : '';
  } catch {
    return 'Preview quality could not be checked. Confirm every line is readable.';
  }
}
export const teachingPhotoAccept =
  'image/jpeg,image/png,image/webp,image/avif,image/heic,image/heif,.heic,.heif';
export function supportedTeachingPhoto(file: File) {
  return (
    ['image/png', 'image/jpeg', 'image/webp', 'image/avif', 'image/heic', 'image/heif'].includes(
      file.type,
    ) ||
    ((!file.type || file.type === 'application/octet-stream') && /\.hei[cf]$/i.test(file.name))
  );
}
